<template>
  <span class="research-image">
    <img v-show="!failed" ref="image" v-bind="$attrs" :src="src" :alt="alt" @error="failed = true" />
    <span v-if="failed" class="research-image-unavailable" role="status">
      <span>{{ zh ? '原始圖片目前無法載入。' : 'The original image is currently unavailable.' }}</span>
      <a :href="src" target="_blank" rel="noopener noreferrer">{{ zh ? '開啟原圖來源' : 'Open original image source' }} ↗︎</a>
    </span>
  </span>
</template>
<script setup>
import { computed, onMounted, ref, watch } from 'vue'
import { useRoute } from 'vue-router'
defineOptions({ inheritAttrs: false })
const props = defineProps({ src: { type: String, required: true }, alt: { type: String, default: '' } })
const route = useRoute()
const zh = computed(() => route.path.startsWith('/zh/'))
const failed = ref(false)
const image = ref(null)
watch(() => props.src, () => { failed.value = false })
onMounted(() => {
  if (image.value?.complete && image.value.currentSrc && image.value.naturalWidth === 0) failed.value = true
})
</script>
<style scoped>
.research-image { display: block; max-width: 100%; }
.research-image-unavailable { display: grid; gap: 8px; padding: 20px; border: 1px solid var(--line-2); color: var(--ink-2); font-size: 1rem; line-height: 1.7; }
.research-image-unavailable a { display: inline-flex; align-items: center; min-height: 44px; width: fit-content; color: var(--ink); text-decoration: underline; text-underline-offset: 3px; }
.research-image-unavailable a:focus-visible { outline: 2px solid var(--gold); outline-offset: 3px; }
</style>
